// Tags disponiveis nos modelos de e-mail (Cadastro > Modelos de E-mail) e usadas pra montar o
// assunto/corpo de verdade quando o corretor envia um anexo pra um segurado (ver botao "Enviar"
// na aba Anexos da Proposta/Apolice). Mantém em sincronia com os campos que substituirTagsEmail
// sabe preencher.
export const TAGS_EMAIL = [
  { tag: '{{nome}}', descricao: 'Nome do segurado' },
  { tag: '{{primeiro_nome}}', descricao: 'Só o primeiro nome do segurado' },
  { tag: '{{cpf_cnpj}}', descricao: 'CPF/CNPJ do segurado' },
  { tag: '{{seguradora}}', descricao: 'Seguradora' },
  { tag: '{{ramo}}', descricao: 'Ramo do seguro' },
  { tag: '{{tipo_documento}}', descricao: 'Proposta, Apólice ou Endosso' },
  { tag: '{{numero_apolice}}', descricao: 'Número da apólice' },
  { tag: '{{numero_proposta}}', descricao: 'Número da proposta' },
  { tag: '{{vigencia_inicio}}', descricao: 'Início da vigência' },
  { tag: '{{vigencia_fim}}', descricao: 'Fim da vigência' },
  { tag: '{{premio_total}}', descricao: 'Prêmio total' },
  { tag: '{{item}}', descricao: 'O item da apólice: veículo/chassi (Automóvel, Carta Verde), endereço do local de risco (Residencial, Empresarial, Condomínio), nome do ramo (Vida Individual, Vida em Grupo, Acidentes Pessoais, Responsabilidade Civil, Viagem) ou modelo (Bike, Equipamentos)' },
  { tag: '{{central_segurado}}', descricao: 'Telefone "Central Segurado" cadastrado na seguradora' },
  { tag: '{{link_assistencia}}', descricao: 'Link "Assistência" cadastrado na seguradora' },
  { tag: '{{link_assinatura}}', descricao: 'Link da assinatura digital da proposta' },
]

// Concordancia com o tipo do documento: {{feminino|masculino}} vira a 1a forma pra Proposta/Apólice
// e a 2a pra Endosso (palavra masculina). Ex.: "{{Sua|Seu}} {{tipo_documento}} está {{emitida|emitido}}".
export const TAG_GENERO = { tag: '{{feminino|masculino}}', descricao: 'Concorda com o tipo do documento: 1ª forma para Proposta/Apólice, 2ª para Endosso. Ex.: {{Sua|Seu}} {{tipo_documento}} está {{emitida|emitido}}' }

export const substituirTagsEmail = (texto, dados) => {
  if (!texto) return ''
  const masculino = dados.tipo_documento === 'Endosso'
  return TAGS_EMAIL.reduce((acc, { tag }) => {
    const chave = tag.replace(/[{}]/g, '')
    const valor = dados[chave] ?? ''
    return acc.split(tag).join(valor)
  }, texto).replace(/\{\{([^{}|]*)\|([^{}|]*)\}\}/g, (_, fem, masc) => masculino ? masc : fem)
}

const RAMOS_VEICULO = ['Automóvel', 'Carta Verde']
const RAMOS_LOCAL_RISCO = ['Residencial', 'Empresarial', 'Condomínio']
const RAMOS_SO_NOME = ['Vida Individual', 'Vida em Grupo', 'Acidentes Pessoais', 'Responsabilidade Civil', 'Viagem']

// Resolve a tag {{item}} a partir do ramo do documento e do primeiro item cadastrado nele (ver
// aba Itens da Proposta/Apólice). Cada ramo mostra a informação que realmente identifica o que
// esta sendo segurado, ja que os campos do item variam (veiculo, endereco, so o nome do ramo...).
export const construirTagItem = (ramo, item) => {
  if (RAMOS_SO_NOME.includes(ramo)) return ramo || ''
  if (RAMOS_VEICULO.includes(ramo)) {
    if (!item) return ''
    return [item.item_modelo, item.item_placa && `Placa ${item.item_placa}`, item.item_chassi && `Chassi ${item.item_chassi}`]
      .filter(Boolean).join(' - ')
  }
  if (RAMOS_LOCAL_RISCO.includes(ramo)) {
    if (!item) return ''
    return [
      [item.res_endereco, item.res_numero].filter(Boolean).join(', '),
      item.res_complemento,
      item.res_bairro,
      [item.res_cidade, item.res_estado].filter(Boolean).join('/'),
    ].filter(Boolean).join(' - ')
  }
  // Bike, Equipamentos e qualquer outro ramo sem campos proprios: usa a descricao/modelo do item.
  return item?.descricao_item || ''
}

// {{central_segurado}} e {{link_assistencia}} vem do cadastro da seguradora (Cadastro >
// Seguradoras > Telefones/Links), buscando pelo tipo exato cadastrado la.
export const dadosSeguradoraParaTags = (seguradora) => ({
  central_segurado: seguradora?.telefones?.find(t => t.tipo === 'Central Segurado')?.numero || '',
  link_assistencia: seguradora?.links?.find(l => l.tipo === 'Assistência')?.link || '',
})
